import axios from 'axios';

export async function importFromCrm(ids, crmName, params = {}) {
  let url = `/api/?entity=groups&action=crmGroupsImport&crm=${crmName}`;
  if (params.campaignId) {
    url = `${url}&campaignId=${params.campaignId}`;
  } else if (params.groupId) {
    url = `${url}&groupId=${params.groupId}`;
  }
  const {data} = await axios.post(url, {groups: ids});
  return data;
}
